module.exports = __webpack_public_path__ + "static/media/overdue1.b2ef9c4b.svg";